var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"parallax",rawName:"v-parallax"}],ref:"conclusion",staticClass:"conclusion-wrap"},[_c('v-preface-conclusion',{attrs:{"data":_vm.pageDataItem.page0.data,"bg":"images/conclusion/bg.jpg","name":_vm.$TL.episode8}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }